import { ICreativeFileType } from "media/model"
import { mediaRPO } from "media/repository"
import React from "react"
import { FlexBox } from "ui/components/FlexBox"
import { MediaDisplay } from "./MediaDisplay"

interface IMediaCreativeDisplayProps {
  mediaId: number // ignored if mediaApprovalsByMedias is passed
  creativeId: number // ignored if mediaApprovalsByMedias is passed
  type: ICreativeFileType
  isFullScreen?: boolean
  sx?: any
}

const PARENT_ID: string = "campaign-media-page"

export const MediaCreativeDisplay = React.memo(
  ({ type, mediaId, creativeId, isFullScreen, sx }: IMediaCreativeDisplayProps) => (
    <FlexBox id={PARENT_ID} ai="start" vertical fullWidth sx={{ ...sx }}>
      <MediaDisplay
        mediaUrl={mediaRPO.getMediaCreativeDownloadUrl(mediaId, creativeId)}
        parentDomId={PARENT_ID}
        type={type}
        isFullScreen={isFullScreen}
      />
    </FlexBox>
  )
)
